import { Routes, Route } from "react-router-dom";
import ContactPage from "./ContactPage";
import AccountPage from "./AccountPage";

const ContactRoutes = () => {
  return (
    <Routes>
      <Route path="customer/contact/*" element={<ContactPage />} />
      <Route path="customer/account/*" element={<AccountPage />} />
    </Routes>
  );
};

export default ContactRoutes;
